import { render, staticRenderFns } from "./UfiCertified.vue?vue&type=template&id=2d2b639c&scoped=true"
import script from "./UfiCertified.vue?vue&type=script&lang=js"
export * from "./UfiCertified.vue?vue&type=script&lang=js"
import style0 from "./UfiCertified.vue?vue&type=style&index=0&id=2d2b639c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b639c",
  null
  
)

export default component.exports